<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topTool">
      <van-dropdown-menu>
        <van-dropdown-item v-model="search.moneyId" :options="MoneyList" @change="init" />
        <van-dropdown-item v-model="searchDate" :options="dateList" @change="init" />
        <van-dropdown-item v-model="search.type" :options="typeList" @change="init" />
        <van-dropdown-item v-model="search.isPay" :options="PayTypeList" @change="init" />
      </van-dropdown-menu>
      <!-- <div class="moneyTj">累计 CNY100.00 收入 CNY100.00 佣金 CNY100.00</div> -->
    </div>
    <div class="topEmptyRect" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.moneyLogId" class="moneyRect" @click="onSelectItem(item.moneyLogId)">
        <div v-if="!item.icon" class="icon">
          <i class="iconfont iconstatepay" />
        </div>
        <div v-if="item.icon" class="iconImg">
          <van-image
            round
            width="3.2em"
            height="3.2em"
            fit="cover"
            :src="item.icon?item.icon:'/img/defaultIcon.jpg'"
          />
        </div>
        <div class="title">
          {{ item.about }}
        </div>
        <div class="date">
          <span v-if="item.outOrderId">订单号: {{ item.outOrderId }}</span><br><span> 时间:{{ formatDate(item.createTime,"yyyy/MM/dd hh:mm",true) }}</span>
        </div>
        <div class="price">
          <span v-if="item.price>=0">+{{ ShowMoney(item.price) }}{{ item.currency }}</span>
          <span v-if="item.price<0">{{ ShowMoney(item.price) }}{{ item.currency }}</span>
          <div v-if="item.isFrozen">冻结</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, DropdownMenu, DropdownItem, Image, List, tag } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetHideDiveBossCommission, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Image.name]: Image,
    [List.name]: List,
    [tag.name]: tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '交易列表',
      backurl: '/store/index',
      dateList: [],
      MoneyList: [{ text: '不限账号', value: null }],
      typeList: [{ text: '不限类型', value: '' }],
      PayTypeList: [
        { text: '支出/收入', value: null },
        { text: '支出', value: true },
        { text: '收入', value: false }
      ],
      search: {
        limit: 500,
        page: 1,
        dateBegin: undefined,
        dateEnd: undefined,
        type: '',
        isPay: null,
        moneyId: null
      },
      searchDate: null,
      loading: true,
      finished: false,
      moneyId: undefined,
      list: []
    }
  },
  watch: {
    searchDate(newValue) {
      var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
      console.log('searchDate', newValue)
      this.search.dateBegin = new Date(newValue)

      var tm = this.search.dateBegin.getTime() + utcToLoacl
      this.search.dateBegin = new Date(tm)

      var date = new Date(newValue)
      console.log('searchDate', date)
      var sdEnd = date.setMonth((date.getMonth() + 1))// 一个月
      this.search.dateEnd = new Date(sdEnd)
      var tm2 = this.search.dateEnd.getTime() + utcToLoacl
      this.search.dateEnd = new Date(tm2)
    }
  },
  created() {
    this.moneyId = getUrlKey('moneyId')
    this.titleTop = GetSysTitle()
    if (this.moneyId) {
      this.search.moneyId = this.moneyId
    }

    this.dateList = [{ text: '不限时间', value: null }]
    var dtNow = new Date().setMonth((new Date().getMonth() + 1))
    dtNow = new Date(dtNow)
    for (var i = 0; i < 12; i++) {
      var sdtime = dtNow.setMonth((dtNow.getMonth() - 1))// 一个月
      console.log('sdTime', formatDate(sdtime, 'yyyy-MM'))
      this.dateList.push({ text: formatDate(sdtime, 'yyyy-MM'), value: formatDate(sdtime, 'yyyy-MM') + '-01' })
    }

    this.getMoneyAccountList(() => {
      this.typeList = JSON.parse(JSON.stringify(GetEnumList('Em_MoneyLogType')))
      this.typeList.unshift({ text: '不限类型', value: '' })
    })
    this.init()
  },
  methods: {
    GetHideDiveBossCommission,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/Pro/getMoneyLogSimple',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    getMoneyAccountList(callback) {
      request({
        url: '/Pro/getMoneyStatistics',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.MoneyList = [{ text: '不限账号', value: null }]
        response.data.moneys.forEach(item => {
          var text = ''
          if (item.manageType === 'SYSTEM' && !item.masterType) {
            text = '[平台]'
          } else if (item.manageType === 'SYSTEM' && item.masterType === 'MANAGE') {
            text = '[平台个人]'
          } else if (item.manageType === 'SYSTEM' && item.masterType === 'STOREAGENT') {
            text = '[平台商城代理]'
          } else if (item.manageType === 'SYSTEM' && item.masterType === 'STORE') {
            text = '[平台商城]'
          } else if (item.manageType === 'SYSTEM' && item.masterType === 'SUPPLIER') {
            text = '[平台供应商]'
          } else if (item.manageType === 'DIVESHOP' && item.masterType === 'MANAGE') {
            text = '[潜店]'
          } else if (item.manageType === 'STORE' && item.masterType === 'MANAGE') {
            text = '[俱乐部]'
          }
          if (item.manageType !== 'SYSTEM' || !GetHideDiveBossCommission()) {
            this.MoneyList.push({ text: text + item.manageName + item.currency + '账户', value: item.moneyId })
          }
        })
        if (callback) {
          callback()
        }
      })
    },
    onSelectItem(logId) {
      // this.$router.push('/pro/moneyInfo/' + logId)
    }
  }
}
</script>
<style scoped>
.topTool{
    position: fixed;
    top: 3em;
    left: 0;
    right: 0;
    z-index: 10;
}
.topEmptyRect{
    height: 3em;
}
.moneyTj{
    background-color: #fff;
    border-bottom: 1px solid #cacaca;
    padding: 0.3em 0.5em;
    font-size: 0.8em;
    color: #999;
}
.moneyRect{
    position: relative;
    height: 5.5em;
}
.moneyRect .icon{
    position: absolute;
    width: 3.2em;
    height: 3.2em;
    top: 0.6em;
    left: 0.5em;
    background-color: #999;
    border-radius: 3.2em;
    text-align: center;
    line-height: 3.2em;
    color: #fff;
}
.moneyRect .iconImg{
   position: absolute;
    top: 1.2em;
    left: 0.5em;
}
.moneyRect .title{
    position: absolute;
    left: 5em;
    top:1em;
    right: 7em;
    font-size: 0.9em;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.moneyRect .date{
    position: absolute;
    color: #999;
    left: 5em;
    top:3.8em;
    bottom: 0;
    right: 7em;
    font-size: 0.9em;
    line-height: 1.1em;
    border-bottom: 1px solid #cacaca;
}
.moneyRect .date span{
    font-size: 0.8em;
}

.moneyRect .price{
    position: absolute;
    right: 1em;
    top:1.1em;
    bottom: 0;
    width: 6em;
    text-align: right;
    border-bottom: 1px solid #cacaca;
    font-size: 0.9em;
    font-weight: 700;
}

.moneyRect .price div{
    font-weight: 400;
    font-size: 0.8em;
    margin-top: 0.5em;
}
</style>
